module.exports = __webpack_public_path__ + "static/media/urgentVsEmergency.63917477.svg";